import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import NotWorking from '../../../forms/notWorking/NotWorking';
import MotiveTitle from '../MotiveTitle';
import ProductColorIcon from '../../../../../../../common/icons/icr_preparando_pedido.svg';

const NotWorkingMobile = ({ ...props }) => {
  const { motiveId, product, profile, type, onData } = props;
  return (
    <Box>
      <MotiveTitle
        icon={ProductColorIcon}
        title="Producto"
        subtitle="No funciona"
        mobile
      />
      <NotWorking
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type={type}
        onData={onData}
      />
    </Box>
  );
};

NotWorkingMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  onData: PropTypes.func,
};

export default NotWorkingMobile;
